module.exports = __webpack_public_path__ + "img/Card_spade_K.13fe1a74.svg";